/** @format */
import qs from 'qs';

import { Query } from '../types';
import { ProductSearchParams } from './types';

const serialize = (value: object) =>
    qs.stringify(value, { arrayFormat: 'comma' });

export function getProductSearchResultsQueryKey(
    baseQuery: Partial<Query>,
    { pageIndex, filterQuery, sort }: ProductSearchParams,
    resultsPerPage: number
) {
    return [
        'productSearchResults',
        serialize(baseQuery),
        serialize({ filterQuery, sort, pageIndex, resultsPerPage }),
    ];
}

export function getProductFacetsQueryKey(baseQuery: Partial<Query>) {
    return ['productSearchFacets', serialize(baseQuery)];
}
